import ModalBindings from '../modal/ModalBindings';
import Validation from '../../../common/assets/js/validation';
import CatalogSearchFilter from '../catalog-search-filter/catalog-search-filter';

export default new class GroupActions {
    constructor() {
        this.hideGroupActionsBtn = '.js-hideGroupActions';
        this.addOffersCommentBtn = '.js-addOffersComment';
        this.productOfferCheckbox = '.js-productOfferCheckbox';
        this.deleteOffersBtn = '.js-deleteOffers';
        this.deleteOffersModalConfirm = '.js-deleteOfferMOdalConfirm';
        this.groupActionsBlock = '.js-groupActions';
        this.productOfferForm = '.js-productOffer';
        this.commentModalConfirmBtn = '.js-commentModalConfirm';
        this.addCommentsModal = '.js-addCommentsPopup';
        this.commentTextarea = '.js-commentTextarea';
        this.commentModalForm = '.js-addCommentForm';
        this.offerComment = '.js-offerComment';
        this.offerModelName = '.js-offerModelName';
        this.selectedOffersIdsArr = [];
        this.footer = '.footer';
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        $(document).on('click', this.hideGroupActionsBtn, (e)=> {
            e.preventDefault();
            $(this.groupActionsBlock).addClass('_hidden');
            $(this.footer).removeClass('_padding-bottom');
        });
        $(document).on('click', this.addOffersCommentBtn, (e)=> {
            e.preventDefault();
            let $addCommentsModal = $('.modal[data-modal="add-comments"]');

            this.setSelectedOfferIds();
            ModalBindings.openModal($addCommentsModal);
            Validation.removeErrors($(this.commentModalForm));
        });
        $(document).on('click', this.deleteOffersBtn, (e)=> {
            e.preventDefault();
            let $deleteOfferModal = $('.modal[data-modal="delete-offer"]');

            ModalBindings.openModal($deleteOfferModal);
            this.setSelectedOfferIds();

            ModalBindings.appendLayoutToPopup(this.getDataToAppendInModal());
            ModalBindings.changeTitleInPopup(this.getDataToAppendInModal());

        });
        $(document).on('click', this.commentModalConfirmBtn, (e)=> {
            e.preventDefault();
            if (Validation.isFormValid($(this.commentModalForm))) {
                this.addCommentRequest($(e.target));
                ModalBindings.hideModal();
            }
        });
        $(document).on('click', this.deleteOffersModalConfirm, (e)=> {
            e.preventDefault();
            this.setSelectedOfferIds();
            this.deleteOffersRequest();
            ModalBindings.hideModal();
        });
    }

    getDataToAppendInModal() {
        let selectedOffersLength = this.selectedOffersIdsArr.length,
            modalData = {};

        if (selectedOffersLength == 1) {
            let modelNamesArr = this.getSelectedOffersModelNamesArr();

            modalData = {
                modalTitle: 'Удалить предложение',
                modelList: `<ul class="modal__model-list">${this.createListOfModelNamesLayout(modelNamesArr)}</ul>`
            };
        } else if (selectedOffersLength > 10) {
            modalData = {
                modalTitle: `Удалить ${this.selectedOffersIdsArr.length} предложений`,
                modelList: `Удалить ${selectedOffersLength} предложений`
            };
        } else {  //if ( 1 < selectedOffersLength <= 10)
            let modelNamesArr = this.getSelectedOffersModelNamesArr();

            modalData = {
                modalTitle: 'Удалить предложения',
                modelList: `<ul class="modal__model-list">${this.createListOfModelNamesLayout(modelNamesArr)}</ul>`
            };
        }

        return modalData;
    }

    getSelectedOffersModelNamesArr() {
        let modelNamesArr = [];

        for (let i = 0; i < this.selectedOffersIdsArr.length; i++) {
            let $currentOfferModelName = $(`${this.productOfferForm}[data-product-offer-id="${this.selectedOffersIdsArr[i]}"]`).find(this.offerModelName).text();

            modelNamesArr.push($currentOfferModelName);
        }

        return modelNamesArr;
    }


    createListOfModelNamesLayout(modelsArr) {
        let layout = '';

        for (let i = 0; i < modelsArr.length; i++) {
            layout += `<li>${modelsArr[i]}</li>`;
        }
        return layout;
    }

    setSelectedOfferIds() {
        this.selectedOffersIdsArr = [];
        let $checkedProductOfferCheckboxesArr = $(`${this.productOfferCheckbox}:checked`);

        for (var i = 0; i < $checkedProductOfferCheckboxesArr.length; i++) {
            let currentForm = $($checkedProductOfferCheckboxesArr[i]).closest(this.productOfferForm);

            this.selectedOffersIdsArr.push(currentForm.attr('data-product-offer-id'));
        }

        return this.selectedOffersIdsArr;
    }

    addCommentRequest($confirmBtn) {
        let textarea = $confirmBtn.closest(this.addCommentsModal).find(this.commentTextarea),
            data = {
                ids: this.selectedOffersIdsArr,
                comment: textarea.val()
            };

        $.request('OffersList::onUpdateComments', {
            data: data,
            loading: '.js-preloaderOverlay',
            complete: (response) => {

                let obResult = response.responseJSON;
                if(!obResult || !obResult.result) {
                    return;
                }
                
                // on ajax response
                this.updateComments(data);
            }
        });

    }

    updateComments(response) {
        for (let i = 0; i < response.ids.length; i++) {
            let $currentComment = $(`[data-product-offer-id="${response.ids[i]}"] ${this.offerComment}`);

            $currentComment.text(response.comment);
        }
    }

    deleteOffers(response) {
        for (let i = 0; i < response.ids.length; i++) {
            let $currentComment = $(`${this.productOfferForm}[data-product-offer-id="${response.ids[i]}"]`);

            $currentComment.remove();
        }
    }

    clearTextField() {
        $(this.addCommentsModal).find(this.commentTextarea).val('');
    }


    deleteOffersRequest() {
        let data = {
            ids: this.selectedOffersIdsArr
        };

        $.request('OffersList::onDeleteOffers', {
            data: data,
            loading: '.js-preloaderOverlay',
            complete: (response) => {

                let obResult = response.responseJSON;
                if(!obResult || !obResult.result) {
                    return;
                }
                
                this.deleteOffers(data);
                CatalogSearchFilter.toggleCheckAllOffersCheckbox();
                CatalogSearchFilter.toggleGroupActions();
                CatalogSearchFilter.setCheckedOffersLength();
            }
        });
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/group-actions/group-actions.js